module.exports = __webpack_public_path__ + "img/pc.52387cac.png";